<div *ngIf="PopupName == 'Create 360 Review'">
  <div class="cardLayout">
    <ion-row>
      <ion-col size="12">
        <div class="popup-heading">
          <div>
            <p class="fs-16 fs_14ForMobile font_bold cl-black">360 Review</p>
          </div>
          <div class="popup-close">
            <span [mat-dialog-close] class="ml-35 mr-5 fs-20 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </div>
  <div class="cardBox">
    <form [formGroup]="createSurveyForm">
      <ion-row>
        <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
          <div class="formLabelSemiBoldfs14 mb-5">360 Review Name</div>
          <mat-form-field class="w-80 mat-height40 mat-input-style mt-10">
            <input matInput type="text" formControlName="review360Name" placeholder="Type text here" maxlength="255">
            <mat-error *ngIf="createSurveyForm.controls['review360Name'].hasError('required')">360 Review Name is
              required</mat-error>
          </mat-form-field>
        </ion-col>
        <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
          <div class="formLabelSemiBoldfs14 mb-5">Start Date</div>
          <mat-form-field class="w-80 mat-height40 mat-input-style mt-10">
            <input readonly matInput dateInput [matDatepicker]="surveyStartDate" placeholder="DD/MM/YYYY"
              formControlName="startDate" [min]="minDate">
            <mat-datepicker-toggle matIconSuffix [for]="surveyStartDate"></mat-datepicker-toggle>
            <mat-datepicker #surveyStartDate></mat-datepicker>
            <mat-error *ngIf="createSurveyForm.controls['startDate'].hasError('required')">Start Date is
              required</mat-error>
          </mat-form-field>
        </ion-col>
        <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
          <div class="formLabelSemiBoldfs14 mb-5">End Date</div>
          <mat-form-field class="w-80 mat-height40 mat-input-style mt-10">
            <input readonly matInput dateInput [matDatepicker]="surveyEndDate" placeholder="DD/MM/YYYY"
              formControlName="endDate" [min]="createSurveyForm.value.startDate">
            <mat-datepicker-toggle matIconSuffix [for]="surveyEndDate"></mat-datepicker-toggle>
            <mat-datepicker #surveyEndDate></mat-datepicker>
            <mat-error *ngIf="createSurveyForm.controls['endDate'].hasError('required')">End Date is
              required</mat-error>
          </mat-form-field>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
            <button type="button" (click)="createSurvey()"
              class="add_btn fs-14 fs_12ForMobile center-content mr-5 mt-10"
              [style.background-color]="buttonColorName">Create New 360 Review</button>
          </div>
        </ion-col>
      </ion-row>
    </form>
  </div>
</div>

<div *ngIf="PopupName == 'View Employees'">
  <div class="cardLayout">
    <ion-row>
      <ion-col size="12">
        <div class="popup-heading">
          <div>
            <p class="fs-16 fs_14ForMobile font_bold cl-black">360 Review Employees</p>
          </div>
          <div class="popup-close">
            <span [mat-dialog-close] class="ml-35 mr-5 fs-20 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </div>
  <div class="cardBox">
    <ion-row>
      <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
        <div class="d-flex">
          <mat-form-field class="mat-height40 mat-input-style">
            <mat-icon matPrefix>search</mat-icon>
            <input matInput type="search" placeholder="Search">
          </mat-form-field>

          <ion-label class="center-content ml-10 fs-14 fs_12ForMobile font_medium pr-10 black_color">Show</ion-label>
          <mat-form-field class="w70px mat-height40 mat-input-style">
            <mat-select placeholder="Select" [(ngModel)]="employeeTablePageCount">
              <mat-option [value]="25">25</mat-option>
              <mat-option [value]="50">50</mat-option>
              <mat-option [value]="75">75</mat-option>
              <mat-option [value]="100">100</mat-option>
            </mat-select>
          </mat-form-field>
          <ion-label class="center-content fs-14 fs_12ForMobile font_medium pl-10 black_color">entries</ion-label>
        </div>
      </ion-col>
      <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
        <div class="verticle-center float-right">
          <div>
            <button type="button" class="export_btn fs-14 fs_12ForMobile center-content mr-10">
              <span class="material-icons fs-20 mr-5">exit_to_app</span>Export</button>
          </div>
          <div>
            <button type="button" class="save_btn" [style.background-color]="buttonColorName">Save</button>
          </div>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12">
        <div class="table-container">
          <table>
            <thead>
              <tr>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  <section class="mat-checkbox-style p-0">
                    <mat-checkbox>Emp. Id.</mat-checkbox>
                  </section>
                </th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  First Name
                </th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  Last Name
                </th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  DOJ
                </th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  Designation
                </th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  Department
                </th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  Manager
                </th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  Location
                </th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  Band
                </th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  Grade
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <section>
                    <mat-checkbox class="mat-checkbox-style">
                      <span class="yellow">E1001</span>
                    </mat-checkbox>
                  </section>
                </td>
                <td>Ankit</td>
                <td>Gupta</td>
                <td>13/05/2024</td>
                <td>Test</td>
                <td>Test</td>
                <td>Ashay Chavan</td>
                <td>Pune</td>
                <td>Sample</td>
                <td>Lorem</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <div>
          <div class="fs-14 fs_12ForMobile font_bold black_color">Showing 1 to 25 entries</div>
        </div>
      </ion-col>
    </ion-row>
  </div>
</div>

<div *ngIf="PopupName == 'Create Email Body'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 fs_14ForMobile font_semibold">360 Review Invitation Email</p>
          </div>
          <div class="popup-close">
            <span [mat-dialog-close] class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 fs_14ForMobile font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <input matInput type="text" placeholder="Type here...">
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <button type="button" class="add_btn fs-14 fs_12ForMobile float-right center-content"
            [style.background-color]="buttonColorName">
            <span class="material-icons fs-16 fs_14ForMobile mr-5">send</span>
            Save
          </button>
        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
            <!-- <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="CreateEmailDescription"></angular-editor> -->
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>

<div *ngIf="PopupName == 'Create Instructions'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-18 fs_16ForMobile font_semibold">360 Review Instructions</p>
          </div>
          <div class="popup-close">
            <span [mat-dialog-close] class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo">
      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div class="fs-16 fs_14ForMobile">Add instructions</div>
          <ion-row>
            <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
              <mat-form-field class="custom-input w-100 mat-input-style">
                <textarea matInput placeholder="Type Here..." rows="5"></textarea>
              </mat-form-field>
              <div class="fs-14 fs_12ForMobile mt-5">Keep your description under 245 characters.</div>
            </ion-col>
            <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
              <button type="button" class="save_btn" [style.background-color]="buttonColorName">Add</button>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
              <div class="table-container-two mt-20">
                <table>
                  <thead>
                    <tr>
                      <th class="fs-14 fs_12ForMobile font_bold cl-black">
                        Instructions
                      </th>
                      <th class="fs-14 fs_12ForMobile font_bold cl-black">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>demo text</td>
                      <td>
                        <img src="././assets/icon/red_delete.svg" alt="Delete">
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
              <button type="button" class="save_btn mt-20" [style.background-color]="buttonColorName">Save</button>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>

<div *ngIf="PopupName == 'Submission Email'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 fs_14ForMobile font_semibold">Submission Email</p>
          </div>
          <div class="popup-close">
            <span [mat-dialog-close] class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 fs_14ForMobile font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <input matInput type="text" placeholder="Enter Subject Here...">
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <button type="button" class="add_btn fs-14 fs_12ForMobile float-right center-content"
            [style.background-color]="buttonColorName">
            <span class="material-icons fs-16 fs_14ForMobile mr-5">send</span>
            Save
          </button>
        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
            <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="submissionEmail"></angular-editor>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>

<div *ngIf="PopupName == 'Stakeholder Identification'">
  <div class="cardLayout">
    <ion-row>
      <ion-col size="12">
        <div class="popup-heading">
          <div>
            <p class="fs-16 fs_14ForMobile font_bold cl-black">Stakeholder Identification</p>
          </div>
          <div class="popup-close">
            <span [mat-dialog-close] class="ml-35 mr-5 fs-20 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </div>
  <div class="cardBox">
    <div class="display-space-between">
      <div class="verticle-center">
        <div>
          <mat-form-field class="mat-height40 mat-input-style pl-10">
            <mat-icon matPrefix>search</mat-icon>
            <input matInput type="search" placeholder="Search" [(ngModel)]="searchString"
              (input)="onSearchStakeholderIdentification($event)">
          </mat-form-field>
        </div>
      </div>
      <div>
        <button *ngIf="!isPublished" type="button" class="add_btn fs-14 fs_12ForMobile float-right center-content"
          [style.background-color]="buttonColorName" (click)="onClickSaveStakeholderIdentification('save')">
          Save
        </button>
      </div>
    </div>

    <div class="table-container mt-20">
      <table>
        <thead>
          <tr>
            <th rowspan="2">For whom the 360 review is to be done</th>
            <!-- <th>Stakeholder Self</th>
            <th>Superior</th>
            <th>Subordinates</th>
            <th>Peers</th>
            <th>Internal customers</th>
            <th *ngIf="isExternalCustomerEnabled">External</th> -->
        
            <ng-container *ngFor="let stakeholder of stakeHoldersArrayForSetup">
              <th *ngIf="stakeholder.selected &&  stakeholder.name !== 'External Customer'">
                Stakeholder {{ stakeholder.name }}
              </th>
              <th *ngIf="stakeholder.name=='External Customer' && stakeholder.selected">
                External
              </th>
            </ng-container>
            <!-- <ng-container *ngFor="let stakeholder of stakeHoldersArrayForSetup">
              <th *ngIf="stakeholder.name=='External Customer' && stakeholder.selected">
                External
              </th>
            </ng-container> -->
            <!-- <th *ngIf="isExternalCustomerEnabled">External</th> -->
            <!-- <th></th> -->
          </tr>
          <!-- <tr>
            <th>
              <mat-form-field class="mat-height40 mat-input-style pl-10 w-100">
                <input matInput type="number" placeholder="Type Here" [(ngModel)]="selfWeightage">
              </mat-form-field>
            </th>
            <th>
              <mat-form-field class="mat-height40 mat-input-style pl-10 w-100">
                <input matInput type="number" placeholder="Type Here" [(ngModel)]="superiorWeightage">
              </mat-form-field>
            </th>
            <th>
              <mat-form-field class="mat-height40 mat-input-style pl-10 w-100">
                <input matInput type="number" placeholder="Type Here" [(ngModel)]="subordinateWeightage">
              </mat-form-field>
            </th>
            <th>
              <mat-form-field class="mat-height40 mat-input-style pl-10 w-100">
                <input matInput type="number" placeholder="Type Here" [(ngModel)]="peerWeightage">
              </mat-form-field>
            </th>
            <th>
              <mat-form-field class="mat-height40 mat-input-style pl-10 w-100">
                <input matInput type="number" placeholder="Type Here" [(ngModel)]="internalCustomerWeightage">
              </mat-form-field>
            </th>
            <th *ngIf="isExternalCustomerEnabled">
              <mat-form-field class="mat-height40 mat-input-style pl-10 w-100">
                <input matInput type="number" placeholder="Type Here" [(ngModel)]="externalCustomerWeightage">
              </mat-form-field>
            </th>
  
          </tr> -->

          <tr>
            <ng-container *ngFor="let stakeholder of stakeHoldersArrayForSetup">
              <th *ngIf="stakeholder.selected && stakeholder.name !== 'External Customer'">
                <mat-form-field class="mat-height40 mat-input-style pl-10 w-100">
                  <input matInput type="number" placeholder="Type Here" [(ngModel)]="stakeholder.weightage" />
                </mat-form-field>
              </th>
                <!-- External customer input -->
              <th *ngIf="stakeholder.name == 'External Customer' && stakeholder.selected">
                <mat-form-field class="mat-height40 mat-input-style pl-10 w-100">
                  <input matInput type="number" placeholder="Type Here" [(ngModel)]="stakeholder.weightage" />
                </mat-form-field>
              </th>
            </ng-container>


              <!-- <ng-container *ngFor="let stakeholder of stakeHoldersArrayForSetup">
              <th *ngIf="stakeholder.name == 'External Customer'">
                <mat-form-field class="mat-height40 mat-input-style pl-10 w-100">
                  <input matInput type="number" placeholder="Type Here" [(ngModel)]="stakeholder.weightage" />
                </mat-form-field>
              </th>
            </ng-container> -->
            <!-- External customer input -->
            <!-- <th *ngIf="isExternalCustomerEnabled">
              <mat-form-field class="mat-height40 mat-input-style pl-10 w-100">
                <input matInput type="number" placeholder="Type Here" [(ngModel)]="externalCustomerWeightage" />
              </mat-form-field>
            </th> -->
          </tr>

        </thead>
        <tbody>
          <tr *ngFor="let item of stakeholderIdentificationArray; let i = index;">
            <!-- Review User Name column -->
            <td>{{ item.reviewUserName }}</td>

            <!-- Loop through selected stakeholders -->
            <ng-container *ngFor="let stakeholder of stakeHoldersArrayForSetup">
              <td *ngIf="stakeholder.selected">

                <!-- Self -->
                <ng-container *ngIf="stakeholder.name === 'Self'">
                  {{ item.stakeHolderSelfUserName }}
                </ng-container>

                <!-- Superior -->
                <ng-container *ngIf="stakeholder.name === 'Superior'">
                  <ng-multiselect-dropdown class="w-100" [placeholder]="'Select Employee'" [settings]="dropdownSettings"
                    [data]="item.superiorUserList" [(ngModel)]="item.selectedSuperiorUserList">
                  </ng-multiselect-dropdown>
                </ng-container>

                <!-- Subordinate -->
                <ng-container *ngIf="stakeholder.name === 'Subordinate'">
                  <ng-multiselect-dropdown class="w-100" [placeholder]="'Select Employee'" [settings]="dropdownSettings"
                    [data]="item.subordinatesUserList" [(ngModel)]="item.selectedSubordinatesUserList">
                  </ng-multiselect-dropdown>
                </ng-container>

                <!-- Peer -->
                <ng-container *ngIf="stakeholder.name === 'Peer'">
                  <ng-multiselect-dropdown class="w-100" [placeholder]="'Select Employee'" [settings]="dropdownSettings"
                    [data]="item.peersUserList" [(ngModel)]="item.selectedPeersUserList">
                  </ng-multiselect-dropdown>
                </ng-container>

                <!-- Internal Customer -->
                <ng-container *ngIf="stakeholder.name === 'Internal Customer'">
                  <ng-multiselect-dropdown class="w-100" [placeholder]="'Select Employee'" [settings]="dropdownSettings"
                    [data]="item.internalCutomerUserList" [(ngModel)]="item.selectedInternalCutomerUserList">
                  </ng-multiselect-dropdown>
                </ng-container>


                <ng-container *ngIf="stakeholder.name === 'External Customer'">
                  <span *ngFor="let ext of item.externaluserList; let isLast=last" class="cp link"
                    (click)="editExtUser(item,'edit')">
                    {{ext.name}}{{isLast ? '' : ', '}}
                  </span>
                  <div class="blue cp" (click)="editExtUser(item,'addPopup')">+ Add</div>
                </ng-container>
              </td>
            </ng-container>

            <!-- External customer -->
            <!-- <td *ngIf="stakeholder.name === 'External Customer'">
              <span *ngFor="let ext of item.externaluserList; let isLast=last" class="cp link"
                (click)="editExtUser(item,'edit')">
                {{ext.name}}{{isLast ? '' : ', '}}
              </span>
              <div class="blue cp" (click)="editExtUser(item,'addPopup')">+ Add</div>
            </td> -->
          </tr>

        </tbody>
      </table>
    </div>
  </div>
</div>

<div *ngIf="PopupName == 'Create Question'">
  <div class="cardLayout">
    <ion-row>
      <ion-col size="12">
        <div class="popup-heading">
          <div>
            <p class="fs-16 fs_14ForMobile font_bold cl-black">Create Stakeholder Identification</p>
          </div>
          <div class="popup-close">
            <span (click)="onClickSaveQuestion('close')"
              class="ml-35 mr-5 fs-20 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </div>
  <div class="cardBox">
    <div class="display-space-between">
      <div class="verticle-center">
        <div>
          <mat-form-field class="mat-height40 mat-input-style pl-10">
            <mat-icon matPrefix>search</mat-icon>
            <input matInput type="search" placeholder="Search" [(ngModel)]="searchText" (input)="onSearch($event)">
          </mat-form-field>
        </div>
      </div>
      <div>
        <button *ngIf="!isPublished" type="button" class="add_btn fs-14 fs_12ForMobile float-right center-content"
          [style.background-color]="buttonColorName" (click)="onClickSaveQuestion('save')">
          Save
        </button>
      </div>
    </div>
    <div class="stakeholder-table mt-20">
      <table>
        <thead>
          <tr>
            <th>Function</th>
            <th>Band</th>
            <th>Competencies</th>
            <th>Questions<span class="red-cl">&nbsp;*</span></th>
            <th>Type (Open/Rating)</th>
          </tr>
        </thead>
        <tbody>

          <ng-container *ngFor="let item of getCompetencyList; let i = index">
            <tr *ngFor="let data of item.competencies; let k = index;let isLast = last">
              <td *ngIf="k === 0" [attr.rowspan]="item.competencies.length">
                {{ item.department }}
              </td>
              <td *ngIf="k === 0" [attr.rowspan]="item.competencies.length">
                {{ item.band }}
              </td>
              <td>
                <div class="verticle-center">
                  <div>
                    {{ data.competencyName }}
                  </div>
                  <div class="ml-10">
                    <img *ngIf="isLast && data.competencyName!='Other'" class="cp" title="Add"
                      src="././assets/icon/Plus_icon.svg" (click)="addCommunicationRow(i,k)">
                    <img *ngIf="isLast && data.competencyName=='Other'" class="cp" title="Remove"
                      src="././assets/icon/Minus_icon.svg" (click)="removeCommunicationRow(i,k)">
                  </div>
                </div>
              </td>
              <td>
                <ng-container *ngFor="let question of data.questions; let j = index;let questionLast = last">
                  <div class="verticle-center mb-5">
                    <mat-form-field class="mat-height40 mat-input-style pl-10 w-100 mw-sm-250">
                      <input matInput type="text" placeholder="Type Here" [(ngModel)]="question.question"
                        maxlength="255" (keyup)="checkMaxLength(question.question)" />
                    </mat-form-field>
                    <div class="ml-10">
                      <img *ngIf="questionLast " class="cp" title="Add" src="././assets/icon/Plus_icon.svg"
                        (click)="addQuestionRow(i,k)">
                      <img *ngIf="j!=0" class="cp" title="Remove" src="././assets/icon/Minus_icon.svg"
                        (click)="removeQuestionRow(i,k,j)">
                    </div>
                  </div>
                </ng-container>
              </td>
              <td>
                <ng-container *ngFor="let question of data.questions; let j = index;let questionLast = last">
                  <ng-select [clearable]="false" class="w170 mat mat-height40 mb-5" placeholder="Select"
                    [(ngModel)]="question.questionType">
                    <ng-option *ngIf="isRatingBased" [value]="'Rating Based'">Rating Based</ng-option>
                    <ng-option *ngIf="isOpenEnded" [value]="'Open Ended'">Open Ended</ng-option>
                  </ng-select>
                </ng-container>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

  </div>
</div>